import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  watch,
  onMounted,
  withDefaults,
} from 'vue';
import TuiButton from '../Button.vue';
import SvgIcon from '../SvgIcon.vue';
import CloseIcon from '../../icons/CloseIcon.vue';
import { isMobile } from '../../../../utils/environment';
import useZIndex from '../../../../hooks/useZIndex';

type BeforeCloseFn = (action?: Action) => void;

interface Props {
  title: string;
  message: string;
  callback?: BeforeCloseFn | null;
  duration: number;
  cancelButtonText: string;
  confirmButtonText: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  remove: Function;
}

type Action = 'cancel' | 'confirm' | 'close';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: { default: '' },
    message: { default: '' },
    callback: { type: [Function, null], default: null },
    duration: { default: Infinity },
    cancelButtonText: { default: '' },
    confirmButtonText: { default: '' },
    remove: { type: Function, default: () => {} }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, message: string, callback: BeforeCloseFn | null, duration: number, cancelButtonText: string, confirmButtonText: string, remove: Function };

const visible = ref(false);
const overlayContentStyle = ref({});
const { nextZIndex } = useZIndex();
let timer: number | null = null;



watch(visible, val => {
  if (val) {
    overlayContentStyle.value = { zIndex: nextZIndex() };
  }
});



function handleClose(action: Action) {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  props.callback && props.callback(action);
  doClose();
}

function doClose() {
  visible.value = false;
  props.remove();
  emit('close');
}

function handleOverlayClick(event: any) {
  if (event.target !== event.currentTarget) {
    return;
  }
  handleClose('close');
}

function duration() {
  if (props.duration === Infinity) return;
  timer = setTimeout(() => {
    handleClose('close');
  }, props.duration);
}

function onOpen() {
  visible.value = true;
}
onMounted(async () => {
  onOpen();
  duration();
});

return { __sfc: true,visible, overlayContentStyle, nextZIndex, timer, props, emit, handleClose, doClose, handleOverlayClick, duration, onOpen, TuiButton, SvgIcon, CloseIcon, isMobile }
}

})